import React from 'react'
import PropTypes from 'prop-types'
import { TitlePrimary, SpacerVertical } from 'mage-deps/@klarna/bubble-ui'
import { CMSEntry } from 'mage-cms'
import { EducationAnalytics } from 'education-tools'
import ArticleList from './ArticleList'
import useFilterArticlesByExperiment from './hooks/useFilterArticlesByExperiment'

TopicOverviewPage.propTypes = {
  parameters: PropTypes.shape({
    topicSlug: PropTypes.string
  }),
  navigation: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
    pop: PropTypes.func
  }).isRequired
}

export default function TopicOverviewPage({ parameters: { topicSlug }, navigation }) {
  return (
    <CMSEntry contentType="UHQMTopic" filters={{ slug: topicSlug }}>
      {topic => (
        <div>
          <EducationAnalytics
            category="uhqm/page/topic"
            action="pageview"
            label={topic.name}
            referenceType="topic"
            referenceId={topic.id}
          />

          <TitlePrimary id="uhqm-topic-title">
            <span style={{ overflowWrap: 'break-word' }}>{topic.name}</span>
          </TitlePrimary>

          <SpacerVertical small />

          <Articles articles={topic.articles} />
        </div>
      )}
    </CMSEntry>
  )
}

Articles.propTypes = {
  articles: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
}

function Articles({ articles }) {
  const activeArticles = useFilterArticlesByExperiment(articles)

  if (!activeArticles) return null

  const visibleArticles = filterHiddenArticles(activeArticles)

  return <ArticleList articles={visibleArticles} analyticsCategory="uhqm/article-title/topic" />
}

function filterHiddenArticles(articles) {
  return articles.filter(article => !article.hidden)
}
